var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 43,
    fill: "none",
    viewBox: "0 0 40 43"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2306_173600)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1.427,
    d: "m21.014 3.084 12.161 7.04a2.77 2.77 0 0 1 1.38 2.399v14.079c0 .99-.526 1.904-1.38 2.399l-12.16 7.04a2.75 2.75 0 0 1-2.76 0L6.095 29a2.77 2.77 0 0 1-1.381-2.399v-14.08c0-.99.526-1.904 1.38-2.398l12.161-7.04a2.75 2.75 0 0 1 2.76 0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2306_173600)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M12.136 25.962h2.652v-6.44L11 16.683v8.144c0 .629.51 1.136 1.136 1.136"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M23.879 25.961h2.651c.629 0 1.137-.51 1.137-1.136V16.68l-3.788 2.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M23.879 14.138v4.924l3.788-2.841v-1.515c0-1.405-1.605-2.207-2.728-1.364"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M14.788 19.061v-4.924l4.546 3.409 4.545-3.41v4.925l-4.546 3.41"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5221F",
    d: "M11 14.707v1.515l3.788 2.84V14.14l-1.06-.796C12.601 12.5 11 13.302 11 14.707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2306_173600"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 13h16.667v12.5H11z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2306_173600",
    width: 38.83,
    height: 42.685,
    x: 0.22,
    y: 0.11,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.89
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.200691 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2306_173600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_2306_173600",
    result: "shape"
  })))));
};
export default SvgGmail;